import React from 'react';

import Lozenge from '@atlaskit/lozenge/lozenge';

export default (): React.JSX.Element => <Lozenge isBold>Bold default lozenge</Lozenge>;
